// middleware/userGroup.js
export default async function ({ store }) {
  const userGroupOptions = ['A', 'B', 'C', 'D', 'E'];
  const randomIndex = Math.floor(Math.random() * userGroupOptions.length);
  const userGroup = userGroupOptions[randomIndex];
  await store.dispatch('user/setUserGroup', userGroup);
}
